function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { inBrowser } from "./basic";

var isDef = function isDef(val) {
  return val !== void 0 && val !== null;
};

var isFunction = function isFunction(val) {
  return typeof val === "function";
};

var isObject = function isObject(val) {
  return val !== null && _typeof(val) === "object";
};

var isPromise = function isPromise(val) {
  return isObject(val) && isFunction(val.then) && isFunction(val["catch"]);
};

var isDate = function isDate(val) {
  return Object.prototype.toString.call(val) === "[object Date]" && !Number.isNaN(val.getTime());
};

function isMobile(value) {
  value = value.replace(/[^-|\d]/g, "");
  return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
}

var isNumeric = function isNumeric(val) {
  return typeof val === "number" || /^\d+(\.\d+)?$/.test(val);
};

var isIOS = function isIOS() {
  return inBrowser ? /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) : false;
};

export { isDate, isDef, isFunction, isIOS, isMobile, isNumeric, isObject, isPromise };